import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import MenuTable from "../../helpers/MenuTable";
import PlanRNew from "./PlanRNew";


function PlanR(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}


const onBack = () => {
   
    setView({...view, ["v"]:"list", ["id"]:-1 }); 
    getTab();
}


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_news,plan_ramowy', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                       
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("atr-id");        

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

  
        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_news,plan_ramowy_d', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {                     
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }




    if(tab == null)
        {
            setTab([]);
            getTab();
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
        }




        
    if(view.v == 'new')
        {
            return <PlanRNew  userData={props.userData} mainView={props.mainView} onBack={onBack} />
        }

        


        
    return (
        <div className="view_content">
            

            <div className="table_widget">   
            <div className="btn" onClick={changeView} v="new" id="-1"  > nowa pozycja</div>
            </div>

            <div className="bg_center">
 
                <table className="table plan_d" >

                        {
                            tab.map(  (row,ix) => {

                                    return <Fragment>

                                                <tr>
                                                        <td className="title">
                                                            {row.tytul}
                                                        </td>
                                                        <td className="hour">
                                                            {row.godzina} / {row.godzina_do}
                                                        </td>
                                                        <td rowSpan={2}>

                                                        <MenuTable>
                                                                        <ul>                                                                      
                                                                            <li  onClick={goDelete}  atr-id={row.id}  >usuń</li>
                                                                        </ul>                                                               
                                                            </MenuTable>  

                                                        </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan={2}>
                                                        {row.opis}
                                                        <br/>&nbsp;
                                                    </td>                                                   
                                                </tr>                                                                                                 
                                                

                                                
                                    </Fragment>

                            } )
                        }

                </table>

            </div>



        </div>
    )
}


export default PlanR;